import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faCloud, faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import Button from '../ui/Button/Button';
import principalImg from '../../imagens/principal.svg';
import principalMenorImg from '../../imagens/principalmenor.svg';
import './Hero.css';

const Hero = ({ onContactClick }) => {
  return (
    <section className="hero">
      <div className="hero__background">
        <div className="hero__gradient"></div>
        <div className="hero__pattern"></div>
        {/* Blobs decorativos */}
        <div className="hero__blob hero__blob--1"></div>
        <div className="hero__blob hero__blob--2"></div>
        <div className="hero__blob hero__blob--3"></div>
      </div>

      {/* Grid split: texto à esquerda (container) | imagem à direita (full-bleed) */}
      <div className="hero__split">
        {/* Coluna esquerda — conteúdo dentro dos limites do container */}
        <div className="hero__left">
          <div className="hero__text">

            {/* Label topo — estilo Conta Azul */}
            <span className="hero__eyebrow">SISTEMA DE GESTÃO COMPLETO</span>

            {/* Headline principal */}
            <h1 className="hero__title">
              ERP específico para lojas de{' '}
              <span className="hero__title-gradient">Roupas e Calçados</span>
            </h1>

            {/* Diferenciais */}
            <div className="hero__desc-list">
              <span className="hero__desc-item">Organização para operar</span>
              <span className="hero__desc-sep" aria-hidden="true">•</span>
              <span className="hero__desc-item">Controle para crescer</span>
              <span className="hero__desc-sep" aria-hidden="true">•</span>
              <span className="hero__desc-item">Inteligência para decidir</span>
            </div>

            <div className="hero__actions">
              <Button
                variant="accent"
                size="lg"
                onClick={onContactClick}
                className="hero__contact-btn"
              >
                Solicite uma demonstração grátis
              </Button>
            </div>
          </div>
        </div>

        {/* Coluna direita — imagem sem padding, sangra até a borda da tela */}
        <div className="hero__image">
          <picture>
            <source media="(max-width: 800px)" srcSet={principalMenorImg} />
            <img
              src={principalImg}
              alt="Sistema Informezz em uso"
              className="hero__image-img"
            />
          </picture>

          {/* Floating Cards
          <div className="hero__floating-card hero__floating-card--1">
            <div className="hero__card-icon">📊</div>
            <div>
              <strong>Análises em tempo real</strong>
              <p>Insights precisos do seu negócio</p>
            </div>
          </div>

          <div className="hero__floating-card hero__floating-card--2">
            <div className="hero__card-icon">🤖</div>
            <div>
              <strong>IA Integrada</strong>
              <p>Sugestões inteligentes para compras e vendas</p>
            </div>
          </div> */}
        </div>
      </div>

      {/* Trust Badges — dentro do container, abaixo do split */}
      <div className="container">
        <div className="hero__trust-row">
          <div className="hero__trust">
            <div className="hero__trust-item">
              <FontAwesomeIcon icon={faLayerGroup} />
              <div>
                <strong>ERP Completo</strong>
                <span>Tudo em um só lugar</span>
              </div>
            </div>
            <div className="hero__trust-item">
              <FontAwesomeIcon icon={faCloud} />
              <div>
                <strong>100% em Nuvem</strong>
                <span>Acesse de qualquer lugar</span>
              </div>
            </div>
            <div className="hero__trust-item">
              <FontAwesomeIcon icon={faShieldAlt} />
              <div>
                <strong>Segurança Total</strong>
                <span>Seus dados protegidos</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
